import PersonIcon from "@mui/icons-material/Person";
import DashboardCustomizeIcon from "@mui/icons-material/DashboardCustomize";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import PeopleIcon from "@mui/icons-material/People";
import Diversity2Icon from "@mui/icons-material/Diversity2";
import {
  AccountBalanceWallet,
  AssignmentTurnedIn,
  CameraFront,
  CreditScore,
  Description,
  DeviceHub,
  Groups,
  HolidayVillage,
} from "@mui/icons-material";

export const HrmsSideBarList = [
  {
    text: "Dashboard",
    icons: DashboardCustomizeIcon,
    link: "/HrManagement/dashboard",
    module: "HrmsDashboard",
    task: "sidebar",
  },
  {
    text: "Users",
    icons: Groups,
    link: "/HrManagement/users",
    module: "Users",
    task: "sidebar",
  },
  {
    text: "Attendance",
    icons: TaskAltIcon,
    link: "/HrManagement/attendance",
    customLink: "/HrManagement/individualAtt",
    module: "Attendance",
    task: "sidebar",
  },
  {
    text: "Leaves",
    icons: PersonIcon,
    link: "/HrManagement/leaves",
    module: "Leaves",
    task: "sidebar",
  },
  {
    text: "Interview",
    icons: Diversity2Icon,
    link: "/HrManagement/interview",
    module: "Recruitment",
    task: "sidebar",
  },
];

export const payrollItems = [
  {
    title: "Payroll",
    icon: CreditScore,
    module: "Payroll",
    task: "sidebar",
    subItems: [
      {
        text: "Departments",
        icons: DeviceHub,
        link: "/HrManagement/payroll/department",
        module: "Department",
        task: "sidebar",
      },
      {
        text: "Shifts",
        icons: CameraFront,
        link: "/HrManagement/shift",
        module: "Shift",
        task: "sidebar",
      },
      {
        text: "Off Days",
        icons: AssignmentTurnedIn,
        link: "/HrManagement/offDays",
        module: "OffDay",
        task: "sidebar",
      },
      {
        text: "Allowances",
        icons: Description,
        link: "/HrManagement/allowance",
        module: "Allowence",
        task: "sidebar",
      },
      {
        text: "Public Holidays",
        icons: HolidayVillage,
        link: "/HrManagement/holidays",
        module: "Holiday",
        task: "sidebar",
      },
      {
        text: "Salaries",
        icons: AccountBalanceWallet,
        link: "/HrManagement/salary-slips",
        module: "Salary",
        task: "sidebar",
      },
    ],
  },
];
